import axios from "axios";
import {getHeader, getHospitalProfileURL, getHospitalDoctorsURL} from "../../config";
import {types} from "../types/globalTypes";
import {hospitalTypes} from "../types/hospitalTypes";


export const getHospitalProfile = (hospital_id) => {
    return (dispatch) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.post(getHospitalProfileURL, {hospital_id},{headers: getHeader()}).then(response => {
            if (response.data.Error.code === 20) {
                dispatch({
                    type: hospitalTypes.GET_HOSPITAL_PROFILE,
                    payload: response.data.Response,
                })
                document.title = response.data.Response ? response.data.Response.profile.name : "Hospital";
            }else{
                dispatch({
                    type: hospitalTypes.CURRENT_HOSPITAL_NOT_FOUND,
                    payload: true
                });
            }
        }).catch(error => {
            if (error) {
                dispatch({
                    type: types.ERROR_500,
                    payload: true,
                });

            }
        })
    }
};

export const getHospitalDoctors = (hospital_id, branch_id = -1, speciality_id = -1, limit = 4 , offset = 0) => {
    return (dispatch) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        dispatch({
            type: hospitalTypes.FETCHING_MORE_HOSPITAL_DOCTORS,
            payload: true,
        });
        axios.post(getHospitalDoctorsURL, {hospital_id,branch_id,speciality_id, limit, offset},{headers: getHeader()}).then(response => {
            if (response.data.Error.code === 20) {
                dispatch({
                    type: hospitalTypes.GET_HOSPITAL_DOCTORS,
                    payload: response.data.Response,
                });
                if(response.data.Response.length < 4) {
                    dispatch({
                        type: hospitalTypes.NO_MORE_HOSPITAL_DOCTORS,
                        payload: true,
                    });
                }
                dispatch({
                    type: hospitalTypes.FETCHING_MORE_HOSPITAL_DOCTORS,
                    payload: false,
                });
            }
        }).catch(error => {
            if (error) {
                dispatch({
                    type: types.ERROR_500,
                    payload: true,
                });

            }
        })
    }
};
export const clearHospitalProfile = () => {
    return (dispatch) => {
        dispatch({
            type: hospitalTypes.CLEAR_HOSPITAL_PROFILE,
            payload: []
        });
    }
};
export const clearHospitalDoctorsList = () => {
    return (dispatch) => {
        dispatch({
            type: hospitalTypes.CLEAR_HOSPITAL_DOCTORS_LIST,
            payload: []
        });
    }
};

export const setHospitalDoctorsSearchData = (data) => {
    return (dispatch) => {
        dispatch({
            type: hospitalTypes.SET_HOSPITAL_DOCTORS_SEARCH_DATA,
            payload: data
        });
    }
};

export const clearHospitalDoctorsSearchData = () => {
    return (dispatch) => {
        dispatch({
            type: hospitalTypes.CLEAR_HOSPITAL_DOCTORS_SEARCH_DATA,
            payload: null
        });
    }
};